import { render, staticRenderFns } from "./ModifyAppointmentHistory.vue?vue&type=template&id=af83a366"
import script from "./ModifyAppointmentHistory.vue?vue&type=script&lang=js"
export * from "./ModifyAppointmentHistory.vue?vue&type=script&lang=js"
import style0 from "./ModifyAppointmentHistory.vue?vue&type=style&index=0&id=af83a366&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports